"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.DefaultSimpleModalOptionConfig = new core_1.InjectionToken('default-simple-modal.config');
var SimpleModalOptions = (function () {
    function SimpleModalOptions() {
    }
    return SimpleModalOptions;
}());
exports.SimpleModalOptions = SimpleModalOptions;
exports.defaultSimpleModalOptions = {
    closeOnEscape: false,
    closeOnClickOutside: false,
    bodyClass: 'modal-open',
    wrapperDefaultClasses: 'modal fade-anim',
    wrapperClass: 'in',
    animationDuration: 300
};
//# sourceMappingURL=simple-modal-options.js.map